import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import Sidebar from '../component/Sidebar';
import Header from '../component/Header';
import Loader from '../component/Loader';
import { useUser } from '../context/UserContext';

const InactiveUser = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', fontFamily: 'GB-BodyCopy' }}>
    <h2 style={{ color: '#810055' }}>Account Inactive</h2>
    <p style={{ color: '#707070', marginTop: '10px' }}>Your account has been deactivated. Please contact your administrator for assistance.</p>
  </div>
);

const MainLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const timerRef = useRef(null);
  const { role } = useUser();

  // GS-SEC-030: Prevent unauthorized access via browser back/refresh after logout
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && accounts.length === 0) {
        sessionStorage.clear();
        window.location.replace('/');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [accounts]);

  useEffect(() => {
    const handleSessionTimeout = async () => {
      try {
        // Clear local storage
        sessionStorage.removeItem('userEmail');
        sessionStorage.removeItem('userDisplayName');
        
        // Clear MSAL accounts and redirect to login
        await instance.logoutRedirect({
          postLogoutRedirectUri: window.location.origin
        });
      } catch (error) {
        console.error('Logout error:', error);
        // Fallback: force redirect to login
        window.location.href = '/';
      }
    };

    const resetTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        console.log('Session expired due to inactivity');
        handleSessionTimeout();
      }, 300000); // 5 minutes = 300000 milliseconds
    };

    const events = ['mousemove', 'mousedown', 'keypress', 'click', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [navigate, instance]);

  // If user is inactive, show inactive message instead of layout
  if (role === "inactive_user") {
    return <InactiveUser />;
  }

  return (
    <div className="wrapper" style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <div 
        id="mainContainer" 
        className="mainContainer"
        style={{
          marginLeft: sidebarCollapsed ? '60px' : '200px',
          transition: 'margin-left 0.3s ease',
          width: sidebarCollapsed ? 'calc(100% - 60px)' : 'calc(100% - 200px)',
          minHeight: '100vh'
        }}
      >
        <Header sidebarCollapsed={sidebarCollapsed} /> 
        <div className="main" style={{ padding: '10px 0 20px 0' }}>
          <Outlet /> 
        </div>
        {/* <Loader /> */}
      </div>
    </div>
  );
};

export default MainLayout;
